// extracted by mini-css-extract-plugin
module.exports =  {"label":"_32bbee5fda--label--qNc_3","input":"_32bbee5fda--input--CFtX4"};